import React, { useEffect, useRef } from "react";

import { createUseStyles } from "react-jss";
import imageStyles from "./ImageStyles";

const useStyles = createUseStyles(imageStyles);

export default ({ style, onClick, imageUrl }) => {
  const canvasRef = useRef();
  const styles = useStyles();

  useEffect(() => {
    if (!imageUrl) return;
    const { current } = canvasRef;
    const ctx = current.getContext("2d");
    const img = new Image();
    img.onload = function () {
      const min = Math.min(img.width, img.height);
      const newWidth = min;
      const newHeight = min;
      const sy = min * 0.1;
      const sx = 0;
      current.height = newHeight;
      current.width = newWidth;
      ctx.drawImage(
        img,
        sx,
        sy,
        newWidth,
        newHeight,
        0,
        0,
        newWidth,
        newHeight
      );
    };
    img.src = imageUrl;
  }, [imageUrl, canvasRef]);
  return (
    <div>
      <canvas
        style={style}
        className={styles.avatarImage}
        ref={canvasRef}
        onClick={onClick}
      />
    </div>
  );
};
